
import React, { useState } from 'react';

export default function WhatsAppFloat() {
  const [isExpanded, setIsExpanded] = useState(false);

  const menuOptions = [
    {
      id: 'reservation',
      icon: 'ri-calendar-line',
      title: 'Reservasi Meja',
      description: 'Book meja untuk dining experience',
      color: 'from-red-500 to-red-600',
      message: 'Halo TAKEYA Restaurant! Saya ingin melakukan reservasi meja. Mohon informasi ketersediaan untuk:\n\n📅 Tanggal: [isi tanggal]\n⏰ Waktu: [isi waktu]\n👥 Jumlah orang: [isi jumlah]\n\nTerima kasih! 🙏'
    },
    {
      id: 'order',
      icon: 'ri-shopping-cart-line',
      title: 'Beli Online',
      description: 'Pesan menu untuk delivery/takeaway',
      color: 'from-green-500 to-green-600',
      message: 'Halo TAKEYA Restaurant! Saya ingin memesan menu untuk:\n\n🚚 □ Delivery ke alamat\n🛍️ □ Take Away\n\n📋 Menu yang ingin dipesan:\n[tuliskan menu yang diinginkan]\n\n📍 Alamat (jika delivery):\n[isi alamat lengkap]\n\nMohon informasi harga dan estimasi waktu. Terima kasih! 🙏'
    },
    {
      id: 'menu',
      icon: 'ri-restaurant-line',
      title: 'Tanya Menu & Harga',
      description: 'Info menu terbaru dan harga',
      color: 'from-yellow-500 to-yellow-600',
      message: 'Halo TAKEYA Restaurant! Saya ingin mengetahui informasi:\n\n📋 Menu terbaru dan harga\n🍜 Rekomendasi menu signature\n🌶️ Level kepedasan menu\n💰 Promo atau paket hemat\n\nMohon kirimkan daftar menu terlengkap. Terima kasih! 🙏'
    },
    {
      id: 'catering',
      icon: 'ri-service-line',
      title: 'Catering & Event',
      description: 'Layanan untuk acara khusus',
      color: 'from-purple-500 to-purple-600',
      message: 'Halo TAKEYA Restaurant! Saya tertarik dengan layanan catering untuk:\n\n🎉 Jenis acara: [isi jenis acara]\n👥 Jumlah tamu: [isi jumlah]\n📅 Tanggal: [isi tanggal]\n📍 Lokasi: [isi lokasi]\n💰 Budget: [isi range budget]\n\n📋 Mohon informasi:\n- Paket catering tersedia\n- Menu yang bisa dipilih\n- Harga per porsi\n- Minimal order\n\nTerima kasih! 🙏'
    },
    {
      id: 'complaint',
      icon: 'ri-customer-service-line',
      title: 'Komplain & Saran',
      description: 'Layanan customer service',
      color: 'from-blue-500 to-blue-600',
      message: 'Halo TAKEYA Restaurant! Saya ingin menyampaikan:\n\n📝 □ Komplain terkait layanan\n💡 □ Saran untuk peningkatan\n❓ □ Pertanyaan umum\n🔄 □ Follow up pesanan\n\nDetail:\n[tuliskan detail komplain/saran/pertanyaan]\n\n📋 Info pesanan (jika ada):\n- Tanggal: [isi tanggal]\n- Nomor order: [isi nomor]\n\nMohon ditindaklanjuti. Terima kasih! 🙏'
    },
    {
      id: 'general',
      icon: 'ri-chat-3-line',
      title: 'Chat Umum',
      description: 'Pertanyaan lainnya',
      color: 'from-gray-500 to-gray-600',
      message: 'Halo TAKEYA Restaurant! Saya ingin bertanya tentang:\n\n[tuliskan pertanyaan Anda]\n\nTerima kasih! 🙏'
    }
  ];

  const handleOptionClick = (option: typeof menuOptions[0]) => {
    const phoneNumber = '628127543743';
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(option.message)}`;
    window.open(whatsappUrl, '_blank');
    setIsExpanded(false);
  };

  const toggleExpanded = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div className="fixed bottom-6 right-6 z-50">
      {/* Backdrop */}
      {isExpanded && (
        <div
          className="fixed inset-0 bg-black/20 backdrop-blur-sm"
          onClick={() => setIsExpanded(false)}
        />
      )}

      {/* Menu Options */}
      {isExpanded && (
        <div className="absolute bottom-20 right-0 w-80 max-h-96 overflow-y-auto bg-white rounded-2xl shadow-2xl border border-gray-200 p-4 space-y-3 animate-in slide-in-from-bottom-4 duration-300">
          <div className="text-center pb-3 border-b border-gray-200">
            <h3 className="text-lg font-bold text-gray-800">Pilih Layanan</h3>
            <p className="text-sm text-gray-600">Bagaimana kami bisa membantu Anda?</p>
          </div>

          {menuOptions.map((option, index) => (
            <button
              key={option.id}
              onClick={() => handleOptionClick(option)}
              className={`w-full flex items-center space-x-3 p-3 rounded-xl bg-gradient-to-r ${option.color} hover:shadow-lg transition-all duration-300 hover:scale-102 cursor-pointer text-left`}
              style={{ animationDelay: `${index * 50}ms` }}
            >
              <div className="w-10 h-10 bg-white/20 rounded-lg flex items-center justify-center flex-shrink-0">
                <i className={`${option.icon} text-white text-lg w-5 h-5 flex items-center justify-center`}></i>
              </div>
              <div className="flex-1 min-w-0">
                <h4 className="text-white font-semibold text-sm whitespace-nowrap overflow-hidden text-ellipsis">
                  {option.title}
                </h4>
                <p className="text-white/80 text-xs">{option.description}</p>
              </div>
              <i className="ri-arrow-right-line text-white/60 w-4 h-4 flex items-center justify-center flex-shrink-0"></i>
            </button>
          ))}

          {/* Quick Contact Info */}
          <div className="bg-gray-50 rounded-xl p-3 mt-4">
            <div className="text-center">
              <p className="text-xs text-gray-600 mb-2">Atau hubungi langsung:</p>
              <div className="flex items-center justify-center space-x-4">
                <div className="flex items-center space-x-1">
                  <i className="ri-phone-line text-green-600 w-3 h-3 flex items-center justify-center"></i>
                  <span className="text-xs text-gray-700">0812-3456-789</span>
                </div>
                <div className="flex items-center space-x-1">
                  <i className="ri-time-line text-blue-600 w-3 h-3 flex items-center justify-center"></i>
                  <span className="text-xs text-gray-700">10:00-23:00</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Main Floating Button */}
      <button
        onClick={toggleExpanded}
        className={`w-14 h-14 rounded-full flex items-center justify-center shadow-2xl transition-all duration-300 cursor-pointer group relative ${
          isExpanded
            ? 'bg-red-500 hover:bg-red-600 rotate-45'
            : 'bg-green-500 hover:bg-green-600'
        }`}
        aria-label="Chat via WhatsApp"
      >
        {isExpanded ? (
          <i className="ri-close-line text-white text-2xl w-6 h-6 flex items-center justify-center"></i>
        ) : (
          <i className="ri-whatsapp-line text-white text-2xl w-6 h-6 flex items-center justify-center group-hover:scale-110 transition-transform"></i>
        )}

        {/* Notification Badge */}
        {!isExpanded && (
          <div className="absolute -top-1 -right-1 w-6 h-6 bg-red-5 00 text-white text-xs font-bold rounded-full flex items-center justify-center animate-pulse">
            6
          </div>
        )}

        {/* Tooltip */}
        {!isExpanded && (
          <div className="absolute right-full mr-3 top-1/2 transform -translate-y-1/2 bg-gray-800 text-white px-3 py-2 rounded-lg text-sm whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
            Pilih Layanan
            <div className="absolute left-full top-1/2 transform -translate-y-1/2 border-4 border-transparent border-l-gray-800"></div>
          </div>
        )}

        {/* Pulse Animation */}
        {!isExpanded && (
          <div className="absolute inset-0 bg-green-500 rounded-full animate-ping opacity-20"></div>
        )}
      </button>

      {/* Status Indicator */}
      <div className="absolute -bottom-2 -left-2 flex items-center space-x-1 bg-white rounded-full px-2 py-1 shadow-lg">
        <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse"></div>
        <span className="text-xs text-gray-700 font-medium">Online</span>
      </div>
    </div>
  );
}
